import {
    DELETE_LOCATION_START,
    DELETE_LOCATION_ERROR,
    DELETE_LOCATION_SUCCESS
} from '../../../constants';
import { deleteLocationMutation, getLocationQuery } from '../../../lib/graphql';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';

export const deleteLocation = (id, currentPage) => {
    return async (dispatch, getState, { client }) => {

        try {

            dispatch({
                type: DELETE_LOCATION_START
            });

            const { data } = await client.mutate({
                mutation: deleteLocationMutation,
                variables: {
                    id
                },
                refetchQueries: [{ query: getLocationQuery, variables: { currentPage, searchList: '' } }]
            });

            if (data?.deleteLocation?.status == 200) {
                dispatch({
                    type: DELETE_LOCATION_SUCCESS
                })
                showToaster({ messageId: 'delLoc', toasterType: 'success' });
            } else {
                dispatch({
                    type: DELETE_LOCATION_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.deleteLocation?.errorMessage }, toasterType: 'error' });
            }
        } catch (err) {
            dispatch({
                type: DELETE_LOCATION_ERROR
            })
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
        }
    }
}